export function useBerekening() {

  function berekenLTV(schuld, wozWaarde) {
    return Math.round((schuld / wozWaarde) * 100)
  }

  function bepaalBracket(ltv, brackets) {
    for (const b of brackets) {
      if (ltv <= b.max) return b
    }
    return brackets[brackets.length - 1]
  }

  function berekenBesparing(schuld, opslagVerschil) {
    const perJaar = schuld * (opslagVerschil / 100)
    const perMaand = perJaar / 12
    return { perJaar, perMaand }
  }

  function berekenMaandRange(perMaandCentral) {
    if (perMaandCentral <= 0) return null
    const round5 = (x, dir) => {
      if (dir === 'down') return Math.max(5, Math.floor(x / 5) * 5)
      return Math.max(5, Math.ceil(x / 5) * 5)
    }
    const lo = round5(perMaandCentral * 0.5, 'down')
    let hi = round5(perMaandCentral * 1.5, 'up')
    if (hi <= lo) hi = lo + 5
    return { lo, hi }
  }

  function formatEuro(bedrag) {
    return '€ ' + Math.round(bedrag).toLocaleString('nl-NL')
  }

  function formatRange(range) {
    if (!range) return '–'
    return `€${range.lo}–€${range.hi}`
  }

  function berekenResultaat(schuld, wozWaarde, verstrekker) {
    const ltv = berekenLTV(schuld, wozWaarde)
    const huidigeBracket = bepaalBracket(ltv, verstrekker.brackets)

    const aanname_oude_opslag = verstrekker.brackets[verstrekker.brackets.length - 1].opslag
    const verschil = aanname_oude_opslag - huidigeBracket.opslag
    const besparing = berekenBesparing(schuld, Math.max(verschil, 0.01))

    const maandRange = berekenMaandRange(besparing.perMaand)
    const jaarRange = maandRange ? { lo: maandRange.lo * 12, hi: maandRange.hi * 12 } : null

    return {
      ltv,
      huidigeBracket,
      verschil,
      besparing,
      maandRange,
      jaarRange
    }
  }

  return {
    berekenLTV,
    bepaalBracket,
    berekenBesparing,
    berekenMaandRange,
    formatEuro,
    formatRange,
    berekenResultaat
  }
}
